<template>
    <span
        :class="[ 'button-arrow-icon', variant ? `button-arrow-icon--${variant}` : null ]"
        aria-hidden="true"
        :style="iconStyle"
    />
</template>

<script>
    import buttonArrowUrl from "@/images/landing-media/button-arrow.svg";

    export default {
        name: "ButtonArrowIcon",
        props: {
            size: {
                type: Number,
                default: 16
            },
            variant: {
                type: String,
                default: null
            }
        },
        computed: {
            iconStyle() {
                return {
                    width: `${this.size}px`,
                    height: `${this.size}px`,
                    display: "block",
                    flexShrink: 0,
                    backgroundColor: "currentColor",
                    WebkitMask: `url(${buttonArrowUrl}) center / contain no-repeat`,
                    mask: `url(${buttonArrowUrl}) center / contain no-repeat`
                };
            }
        }
    }
</script>
